"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const lodash_1 = __importDefault(require("lodash"));
const Pagination = (props) => {
    const PAGES_PER_SUBSET = 5;
    const [pageCount, setPageCount] = (0, react_1.useState)(0);
    const [startSubset, setStartSubset] = (0, react_1.useState)(1);
    const [activePage, setActivePage] = (0, react_1.useState)(1);
    const [pageQuantityToDisplay, setPageQuantityToDisplay] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (props.quantityPerPage > 0) {
            const numberOfPage = Math.ceil(props.total / props.quantityPerPage);
            let page = 1;
            if (props.startPage && props.startPage <= numberOfPage) {
                page = props.startPage;
            }
            setPageCount(numberOfPage);
            changeActivePage(page, false);
            updateSubsets(page, numberOfPage);
        }
    }, [props.total, props.startPage]);
    const updateSubsets = (page, count) => {
        const subsetIndex = Math.ceil(page / PAGES_PER_SUBSET) - 1;
        const newStartSubset = subsetIndex * PAGES_PER_SUBSET + 1;
        setPageQuantityToDisplay(getPageQuantityToDisplay(newStartSubset, count));
        setStartSubset(newStartSubset);
    };
    const changeActivePage = (page, bubbleUp = true) => {
        setActivePage(page);
        if (bubbleUp) {
            props.onPageChange(page);
        }
    };
    const navigatePreviousSubset = () => {
        if (startSubset - PAGES_PER_SUBSET > 0) {
            updatePagination(startSubset - PAGES_PER_SUBSET);
        }
    };
    const navigateNextSubset = () => {
        if (startSubset + PAGES_PER_SUBSET <= pageCount) {
            updatePagination(startSubset + PAGES_PER_SUBSET);
        }
    };
    const navigateFirstPage = () => {
        updatePagination(1);
    };
    const navigateLastPage = () => {
        updatePagination(getLastStartSubset(), pageCount);
    };
    const updatePagination = (startSubset, newPage) => {
        setStartSubset(startSubset);
        setPageQuantityToDisplay(getPageQuantityToDisplay(startSubset, pageCount));
        changeActivePage(newPage ? newPage : startSubset);
    };
    const getLastStartSubset = () => {
        const lastStartSubset = pageCount % PAGES_PER_SUBSET == 0 ? pageCount - PAGES_PER_SUBSET : pageCount - (pageCount % PAGES_PER_SUBSET);
        return lastStartSubset + 1;
    };
    const getPageQuantityToDisplay = (startSubset, pageCount) => {
        return startSubset + PAGES_PER_SUBSET - 1 > pageCount ? pageCount % PAGES_PER_SUBSET : PAGES_PER_SUBSET;
    };
    return (react_1.default.createElement("ul", { className: "boutik-customer-account-mfp-prop-orders-pagination-container", style: { display: "flex" } },
        react_1.default.createElement("button", { disabled: activePage == 1, onClick: navigateFirstPage, className: "boutik-customer-account-mfp-prop-orders-pagination-navigation-btn boutik-customer-account-mfp-prop-orders-pagination-first-page" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.doubleArrow })),
        react_1.default.createElement("button", { disabled: startSubset == 1, onClick: navigatePreviousSubset, className: "boutik-customer-account-mfp-prop-orders-pagination-navigation-btn boutik-customer-account-mfp-prop-orders-pagination-previous-subset" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.singleArrow })),
        react_1.default.createElement("div", { style: { display: "flex" } }, lodash_1.default.times(pageQuantityToDisplay, (index) => (react_1.default.createElement("li", { style: { listStyleType: "none" }, className: `boutik-customer-account-mfp-prop-orders-pagination-page ${activePage === startSubset + index ? "boutik-customer-account-mfp-prop-orders-pagination-active-page" : "boutik-customer-account-mfp-prop-orders-pagination-unactive-page"}`, key: startSubset + index, onClick: () => changeActivePage(startSubset + index) },
            react_1.default.createElement("span", null, startSubset + index))))),
        react_1.default.createElement("button", { disabled: startSubset == getLastStartSubset(), onClick: navigateNextSubset, className: "boutik-customer-account-mfp-prop-orders-pagination-navigation-btn boutik-customer-account-mfp-prop-orders-pagination-next-subset" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.singleArrow })),
        react_1.default.createElement("button", { disabled: activePage == pageCount, onClick: navigateLastPage, className: "boutik-customer-account-mfp-prop-orders-pagination-navigation-btn boutik-customer-account-mfp-prop-orders-pagination-last-page" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.doubleArrow }))));
};
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map